@if (checkpoints().length) {
  <mat-progress-bar
    class="shipment-tracking-progress-bar"
    mode="determinate"
    [value]="progressValue()"
  />
  <div
    class="display-grid justify-content-space-between mt-8"
    [style.grid-template-columns]="gridTemplateColumns()"
  >
    @for (checkpoint of checkpoints(); track checkpoint.status) {
      <div
        class="display-flex flex-direction-column gap-4"
        [ngClass]="{
          'align-items-start': $first,
          'align-items-end': $last,
          'align-items-center': !$first && !$last,
        }"
      >
        <div class="display-flex align-items-center gap-4 mb-4">
          <mat-icon
            [svgIcon]="checkpoint.icon"
            [class]="checkpoint?.iconClassName"
          />
          <span
            class="twc-typography-body-2-medium twc-color-primary-typeface"
            >{{ checkpoint.status }}</span
          >
        </div>
        @if (checkpoint?.templateRef) {
          <ng-container
            *ngTemplateOutlet="checkpoint.templateRef"
          ></ng-container>
        }
      </div>
    }
  </div>
}
